import { useMemo } from "react";
import { AnalyticsCampaign } from "../../../types";

export function useDataOpened(analyticsData: AnalyticsCampaign[] | undefined) {
  return useMemo(
    () => ({
      data: analyticsData?.map((dataItem, index) => ({
        label: "Opened",
        value: dataItem.audienceReached.opened.percentage || 0,
        exactValue: dataItem.audienceReached.opened.amount,
        backgroundColor: index === 0 ? "rgba(99, 102, 241, 0.5)" : undefined,
      })),
      title: analyticsData?.reduce(
        (acc, curr) => acc + curr.audienceReached.opened.amount,
        0
      ),
    }),
    [analyticsData]
  );
}
